// extracted by mini-css-extract-plugin
export default {"main-text":"SX8adM","icon":"uPvG6t","tooltip":"XKIgLd"};